export { SettingsStateService } from "./StateService/SettingsStateService";
export var settingsStateServiceDIKey = "settings_state_service";
//# sourceMappingURL=index.js.map